// extracted by mini-css-extract-plugin
export var PlaceholderImage = "PlaceholderImage-module--PlaceholderImage--C5ekL";
export var aniSpin = "PlaceholderImage-module--ani-spin--UmNaP";
export var inner = "PlaceholderImage-module--inner--cn0bK";